import React, { useMemo } from 'react'
import { DashboardDataLayers } from '../../../../constants/gtm-events/gtm-events-dashboard'
import { useCurrentUser } from '../../../../hooks/current-user-hook'
import UserDropdown from '../../../UserDropdown'

const Component = () => {
  const { userData } = useCurrentUser()

  const initials = useMemo(() => {
    const firstLetterName = userData?.nombreUsuario?.charAt(0) || ''
    const firstLetterLastName = userData?.apellidoUsuario?.charAt(0) || ''
    return `${firstLetterName}${firstLetterLastName}`
  }, [userData])

  const component = () => (
      <UserDropdown
        user={userData!}
        onClick={(_, { content }) => DashboardDataLayers.clickMenuHeader(`Mi cuenta-${content}`)}
        initials={initials}
      />
  )
  const PerformanceComponent = React.memo(component)
  return <PerformanceComponent />
}

export default Component
